import { dateStringToNumber, durationToNumber } from '@/utils/tools';

import { getReasonFromCode ,type  BanReason} from './reasons';
// import { sendRequest } from './network';
// import { fakeCreateBan, fakeUpdateBan } from './fakenetwork';

export interface BanDto {
  ban_id: number; // 2
  banned_by: UserDto;
  created_at: string; // "2024-07-24T15:57:07.45392Z"
  deleted_at: string; // null
  description: string; // "Lorem ipsum"
  duration: string; // "P2D"
  end_at: string; // "2024-07-26T15:57:07.45304Z"
  feature_codes: string[]; // ['CHAT', 'UGC_A', 'UGC_N']
  lifted_reason: string; // "because"
  lifted_at: string; // null
  lifted_by: UserDto;
  player_id: number; // 11
  reason_code: string; // "INSULT"
  start_at: string; // "2024-07-24T15:57:07.45304Z"
  status: string; // "running"
  updated_at: string; // "2024-07-24T15:57:07.45392Z"
}

interface UserDto {
  user_id: string; // 1
  created_at: string; // "2024-07-03T17:14:46.287466+02:00"
  deleted_at: string; // null
  email: string; // "vberdeu@nacon.fr"
  firstname: string; // "Vincent"
  job_title: string; // "Ingénieur Fullstack"
  last_login: string; // "2024-09-20T14:51:46.837449+02:00"
  lastname: string; // "Berdeu"
  login: string; // "vberdeu@nacon.fr"
  updated_at: string; // "2024-07-03T17:14:46.287466+02:00"
}

interface BanStatusType {
  label: string;
  color: string;
}

export const BanStatus = {
  CREATION: { label: 'creation', color: 'blue' },
  RUNNING: { label: 'running', color: 'orange' },
  LIFTED: { label: 'lifted', color: 'green' },
  LAPSED: { label: 'lapsed', color: 'grey' },
  DELETED: { label: 'deleted', color: 'red' },
  UNKNOWN: { label: 'unknown', color: 'pink' },
};

const banStatusLabelToEnumMap: Record<string, BanStatusType> = {
  creation: BanStatus.CREATION,
  running: BanStatus.RUNNING,
  lifted: BanStatus.LIFTED,
  lapsed: BanStatus.LAPSED,
  deleted: BanStatus.DELETED,
  unknown: BanStatus.UNKNOWN,
};

export function banDtoToModel(banDto: BanDto): BanModel {
  const createdAt = dateStringToNumber(banDto.created_at);
  const duration = durationToNumber(banDto.duration);
  const expireAt = createdAt + duration;

  return {
    id: banDto.ban_id.toString(),
    features: banDto.feature_codes,
    reason: getReasonFromCode(banDto.reason_code),
    bannedBy: userDtoToModel(banDto.banned_by),
    createdAt: dateStringToNumber(banDto.created_at),
    expireAt,
    duration: durationToNumber(banDto.duration),
    description: banDto.description,
    status: banStatusLabelToEnumMap[banDto.status] ?? BanStatus.UNKNOWN,
    liftedReason: banDto.lifted_reason,
    liftedBy: userDtoToModel(banDto.lifted_by),
  };
}

export function userDtoToModel(userDto?: UserDto): UserModel {
  if (!userDto) {
    return {};
  }
  const createdAt = dateStringToNumber(userDto.created_at);

  return {
    id: userDto.user_id,
    pseudo: userDto.email.split('@')[0],
    createdAt,
    firstName: userDto.firstname,
    lastName: userDto.lastname,
    email: userDto.email,
  };
}

export interface BanModel {
  id: string;
  playerId?: string;
  bannedBy?: UserModel;
  createdAt?: number;
  expireAt?: number;
  avatar?: string;
  first?: string;
  last?: string;
  twitter?: string;
  notes?: string;
  favorite?: boolean;
  // Wireframe fields
  reason?: BanReason;
  features: string[];
  duration: number;
  description?: string;
  status: BanStatusType;
  liftedReason?: string;
  liftedBy?: UserModel;
}

export interface UserModel {
  id?: string;
  pseudo?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  createdAt?: number;
}
